/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約情報
 */
export interface Sgkb986aResDescriptionDto {
    /**
     * サービス契約番号
     */
    srvCtrNo?: string;
    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * 請求お客さま番号
     */
    recptFixNo?: string;
    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * 会社名
     */
    companyname?: string;
    /**
     * 地区コード
     */
    areacode?: string;
    /**
     * 地区名
     */
    areaMei?: string;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * プロダクト正式名
     */
    prdAname?: string;
    /**
     * プロダクト略式名
     */
    prdRyaku?: string;
    /**
     * プロダクト画面表示用略式名
     */
    prdDispAname?: string;
    /**
     * サービス種別コード
     */
    srvClsfyCode?: string;
    /**
     * サービス種別コード名称
     */
    srvClsfyCodeAname?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * エネルギー種別コード名称
     */
    energyClsfyCodeaname?: string;
    /**
     * 熱量
     */
    heat?: string;
    /**
     * 熱量名称
     */
    heatAname?: string;
    /**
     * プロダクト商品正式名称
     */
    prdGoodsAname?: string;
    /**
     * プロダクト商品略称名称
     */
    prdGoodsRyaku?: string;
    /**
     * プロダクト商品画面用名称
     */
    prdGoodsDisp?: string;
    /**
     * 業種（大分類）
     */
    gyoshuLargebunrui?: string;
    /**
     * 業種（大分類）名称
     */
    gyoshuLargebunruiAname?: string;
    /**
     * 契約開始日付
     */
    ctrstrDate?: string;
    /**
     * 契約終了日付
     */
    ctrendDate?: string;
    /**
     * 契約有効期間開始日付
     */
    ctrefctkiStrtdate?: string;
    /**
     * 商品契約満了予定日付
     */
    ctrExpireDate?: string;
    /**
     * 総合契約区分コード
     */
    sogoCtrDiv?: string;
    /**
     * 総合契約区分コード名称
     */
    combinedcontractDivCodeaname?: string;
    /**
     * 同一地点キー
     */
    sameLocationkey?: string;
    /**
     * 小売機器販売形態コード
     */
    retailequipmentSalesformcode?: string;
    /**
     * 小売機器販売形態コード名称
     */
    retailequipmentSalfrmCodeaname?: string;
    /**
     * 送配電事業者コード
     */
    transCode?: string;
    /**
     * 送配電事業者コード名称
     */
    transCodeAname?: string;
    /**
     * 検針日区分
     */
    ksdateDiv?: string;
    /**
     * 検針日区分名称
     */
    ksdateDivAname?: string;
    /**
     * 基本検針日
     */
    basicKensinDay?: string;
    /**
     * 導管事業者コード
     */
    cndtBusCode?: string;
    /**
     * 導管事業者名称
     */
    cndtBusAname?: string;
    /**
     * 指定日検針日区分コード
     */
    siteiKensinDiv?: string;
    /**
     * 指定日検針日区分コード名称
     */
    siteiKensinDivAname?: string;
    /**
     * 検針日程
     */
    kensinSchdl?: string;
}

